"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStepAnimation = void 0;
var react_1 = require("react");
var react_spring_1 = require("react-spring");
var use_execution_queue_1 = require("use-execution-queue");
var util_1 = require("./util");
var useWindowSize_1 = __importDefault(require("./useWindowSize"));
var useStepAnimation = function (_a) {
    var stepsRef = _a.stepsRef, wrapperRef = _a.wrapperRef, _b = _a.offset, offset = _b === void 0 ? { x: 0, y: 0 } : _b, _c = _a.queueTime, queueTime = _c === void 0 ? 1000 : _c, _d = _a.getPositionsAwaitTime, getPositionsAwaitTime = _d === void 0 ? 50 : _d;
    var _e = (0, useWindowSize_1.default)(), height = _e.height, width = _e.width;
    var addToQueue = (0, use_execution_queue_1.useExecutionQueue)({ intervalTime: queueTime }).addToQueue;
    var _f = (0, react_1.useState)(0), step = _f[0], setStep = _f[1];
    var _g = (0, react_1.useState)([
        { x: 0, y: 0 },
    ]), stepsPositions = _g[0], setStepsPositions = _g[1];
    (0, react_1.useEffect)(function () {
        var getPositions = function () { return __awaiter(void 0, void 0, void 0, function () {
            var wrapperPosition;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, (0, util_1.sleep)(getPositionsAwaitTime)];
                    case 1:
                        _a.sent();
                        wrapperPosition = wrapperRef ? (0, util_1.getPositionByRef)(wrapperRef) : { x: 0, y: 0 };
                        setStepsPositions(stepsRef.map(util_1.getPositionByRef).map(function (_a) {
                            var x = _a.x, y = _a.y;
                            return ({
                                x: x - wrapperPosition.x,
                                y: y - wrapperPosition.y,
                            });
                        }));
                        return [2 /*return*/];
                }
            });
        }); };
        getPositions();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [height, width, getPositionsAwaitTime]);
    var nextStep = (0, react_1.useCallback)(function () {
        addToQueue(function () {
            setStep(function (previous) { return (previous === stepsPositions.length - 1 ? previous : previous + 1); });
        });
    }, [addToQueue, stepsPositions.length]);
    var previousStep = (0, react_1.useCallback)(function () {
        addToQueue(function () { return setStep(function (previous) { return (previous === 0 ? previous : previous - 1); }); });
    }, [addToQueue]);
    var props = (0, react_spring_1.useSpring)({
        top: stepsPositions[step].y + offset.y,
        left: stepsPositions[step].x + offset.x,
    });
    return {
        animationProps: props,
        step: step,
        stepsPositions: stepsPositions,
        nextStep: nextStep,
        previousStep: previousStep,
    };
};
exports.useStepAnimation = useStepAnimation;
